export const production = process.env.NODE_ENV === 'production';

export const serverUrl = process.env.NODE_ENV === 'development' ? 'https://dev-ibank.yelo.az' : '';
